import { useModalContentToggler } from '@components'

import { Flex, Icon, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { QuickStartStep } from '../../../../../quickStart/enums/quickStartStep'
import { useQuickStartProgress } from '../../../../../quickStart/hooks'
import { usePollOpenBankingAutoConnect } from '../../../../hooks/usePollOpenBankingAutoConnect'
import { useOpenBankingAutoConnectModal } from '../../contexts/openBankingAutoConnectContext'
import { OpenBankingAutoConnectModalSteps } from '../../enums/openBankingAutoConnectModalSteps'
import * as Styled from './styles'

export const LoadingModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { targetAccountIds } = useOpenBankingAutoConnectModal()
  const { setActiveState } = useModalContentToggler()
  const { markStepDone } = useQuickStartProgress()

  const { isPolling } = usePollOpenBankingAutoConnect({
    polling: true,
    targetAccountIds,
    onSuccess: () => {
      markStepDone(QuickStartStep.Bank)
      setActiveState(OpenBankingAutoConnectModalSteps.Success)
    },
    onTimeout: () => setActiveState(OpenBankingAutoConnectModalSteps.Error),
  })

  return (
    <Flex flexDirection="column" alignItems="center">
      <Space size="s32" />
      <Styled.IconWrapper isLoading={isPolling}>
        <Icon icon="circleDashed" color="currentColor" />
      </Styled.IconWrapper>
      <Space size="s40" />
      <Text weight="medium" variant="h3">
        {t('bank_connection.open_banking_auto_connect_modal.loading_title')}
      </Text>
      <Space size="s8" />
      <Text variant="bodyLG" colorVariant="discreet">
        {t('bank_connection.open_banking_auto_connect_modal.loading_description')}
      </Text>
      <Space size="s80" />
    </Flex>
  )
}
